module.exports = __webpack_public_path__ + "static/media/chat03-1.676d8723.svg";